// extracted by mini-css-extract-plugin
export default {"main":"HomeHero_main__eQLO1","content":"HomeHero_content__IkgUX","redBtn":"HomeHero_redBtn__h+Vws","transparentBtn":"HomeHero_transparentBtn__bEY2h"};